import { 
  collection, 
  addDoc, 
  getDocs, 
  doc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  serverTimestamp 
} from 'firebase/firestore';
import { db } from '../firebase/config';

const LINEUPS_COLLECTION = 'lineups';

export const lineupService = {
  // Save a new lineup
  async saveLineup(userId, lineupData) {
    try {
      const docRef = await addDoc(collection(db, LINEUPS_COLLECTION), {
        ...lineupData,
        userId,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
      return docRef.id;
    } catch (error) {
      console.error('Error saving lineup:', error);
      throw error;
    }
  },

  // Get all lineups for a user
  async getUserLineups(userId) {
    try {
      const q = query(
        collection(db, LINEUPS_COLLECTION),
        where('userId', '==', userId)
      );
      const querySnapshot = await getDocs(q);
      const lineups = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      // Sort by updatedAt in JavaScript instead of Firestore
      return lineups.sort((a, b) => {
        const aTime = a.updatedAt?.seconds || 0;
        const bTime = b.updatedAt?.seconds || 0;
        return bTime - aTime;
      });
    } catch (error) {
      console.error('Error getting user lineups:', error);
      throw error;
    }
  },

  // Update an existing lineup
  async updateLineup(lineupId, lineupData) {
    try {
      const lineupRef = doc(db, LINEUPS_COLLECTION, lineupId);
      await updateDoc(lineupRef, {
        ...lineupData,
        updatedAt: serverTimestamp()
      });
    } catch (error) {
      console.error('Error updating lineup:', error);
      throw error;
    }
  },

  // Delete a lineup
  async deleteLineup(lineupId) {
    try {
      await deleteDoc(doc(db, LINEUPS_COLLECTION, lineupId));
    } catch (error) {
      console.error('Error deleting lineup:', error);
      throw error;
    }
  },

  // Format lineup data for saving
  formatLineupForSave(lineupName, forwards, defensemen, lineupGoalies, salaries, salaryCap, retainedSalary) {
    return {
      name: lineupName,
      forwards: forwards.map(line => ({
        LW: line.LW ? { id: line.LW.id, name: line.LW.name, positions: line.LW.positions } : null,
        C: line.C ? { id: line.C.id, name: line.C.name, positions: line.C.positions } : null,
        RW: line.RW ? { id: line.RW.id, name: line.RW.name, positions: line.RW.positions } : null
      })),
      defensemen: defensemen.map(line => ({
        D1: line.D1 ? { id: line.D1.id, name: line.D1.name, positions: line.D1.positions } : null,
        D2: line.D2 ? { id: line.D2.id, name: line.D2.name, positions: line.D2.positions } : null
      })),
      goalies: lineupGoalies.map(goalie => 
        goalie ? { id: goalie.id, name: goalie.name, team: goalie.team } : null
      ),
      salaries,
      salaryCap,
      retainedSalary
    };
  }
};